import React from "react";
import "./index.scss";
import { Col, Layout, Row, Typography } from 'antd';
import LogoIcon from "@components/svg/LogoIcon/LogoIcon";
import BackIcon from "@components/svg/BackIcon";
import { PATHS } from "@config/constants";
import { useTranslation } from "react-i18next";

const { Link } = Typography
const LoginLayout = ({ children }) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <Layout className="content-login">
        <Link className="back-to-home" href={PATHS.HOME_PAGE}><BackIcon />{t("login.back_to_homepage")}</Link>
        <main>
          <div className="login-page">
            <Row justify="center">
              <Col xs={24} md={16} lg={12} xl={10}>
                <LogoIcon style={{ fontSize: '40px', color: '#ffffff', marginBottom: '45px' }} />
                {children}
              </Col>
            </Row>
          </div>
        </main>
      </Layout>
    </React.Fragment>
  );
};

export default LoginLayout;
